module.exports = __webpack_public_path__ + "static/img/elebits_port_lg.2d295cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/elebits-web-development/elebits_port_lg.jpg
// module id = 237
// module chunks = 2